(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["umg-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('umg-back-to-top')) {
    customElements.define('umg-back-to-top', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.updateVisibility = () => {
          const shouldHide = window.scrollY < 400;
          if (this.hidden !== shouldHide) this.hidden = shouldHide;
        };
        this.returnToTop = () => {
          const homeLink = document.querySelector('.umg-site-header .umg-brand');
          if (homeLink) homeLink.focus({ preventScroll: true });
          window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };
        window.addEventListener('scroll', this.updateVisibility, { passive: true });
        this.button.addEventListener('click', this.returnToTop);
        this.updateVisibility();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateVisibility);
        if (this.button) this.button.removeEventListener('click', this.returnToTop);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
